import { render, staticRenderFns } from "./JobsCandidates.vue?vue&type=template&id=31637f54&scoped=true&"
import script from "./JobsCandidates.vue?vue&type=script&lang=js&"
export * from "./JobsCandidates.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./JobsCandidates.vue?vue&type=style&index=1&id=31637f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31637f54",
  null
  
)

export default component.exports